import { Descendant } from "slate";

export enum ReplySuggestionRating {
  Positive = 1,
  Negative = -1,
}

export interface IGenerateReplySuggestionResponse {
  ID: string;
  createdAt: string;
  createdBy: string;
  pathID: string;
  replyPathID: string;
  text: string;
  richTextObj?: Descendant[];
}
